// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__14JOE","selects":"Documents_selects__1Kbyx"};